import React, {useEffect, useState} from 'react';
import Spinner from '../reusables/spinner';
import {connect} from 'react-redux';
import {get_supplier} from '../../redux/actions/adminActions';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {Modal} from 'react-bootstrap';
import ProfileEdit from '../admin/suppliers/profileEdit';
import LicenseCapture from '../admin/suppliers/licenseCapture';
import NextOfKin from '../admin/suppliers/nextOfKin';
import ResetPassword from '../admin/suppliers/resetPassword';

function EditSupplierModal({ show, handleClose, user, getSupplier, supplier, unapproved, accessToken}) {

    useEffect(() => {
        if (user) {
            getSupplier(user.id, unapproved ? 'unapproved': 'approved');
        }
    }, [user])
    
    return (
        <Modal show={show} onHide={handleClose} centered>
            <div className="icon--tiny isClickable closeModal" onClick={handleClose}>
                <i class="ri-close-line sectionText--small"></i>
            </div>

            <div className="suppliers py-4">
                <Tabs>
                    <TabList className='alignOnly sectionText pl-0 p-2 mb-0'>
                        <Tab className='tabHead'>Profile</Tab>
                        <Tab className='tabHead'>Driver’s License/Passport</Tab>
                        <Tab className='tabHead'>Next of Kin</Tab>
                        <Tab className='tabHead'>Change Password</Tab>
                    </TabList>

                    <TabPanel>
                        <ProfileEdit user={supplier} close={handleClose} unapproved={unapproved}/>
                    </TabPanel>
                    <TabPanel>
                        <LicenseCapture user={ supplier } close={ handleClose } unapproved={ unapproved }/>
                    </TabPanel>
                    <TabPanel>
                        <NextOfKin user={supplier} close={handleClose}/>
                    </TabPanel>
                    <TabPanel>
                        <ResetPassword userId={supplier?.id} close={handleClose}/>
                    </TabPanel>
                </Tabs>
            </div>
        </Modal>

    )
}

const mapStateToProps = (state) => ({supplier: state.admin.supplier, 
    accessToken: state.admin.token})

const mapDispatchToProps = (dispatch) => ({
    getSupplier: (id, status) => dispatch(get_supplier(id, status))
})

export default connect(mapStateToProps, mapDispatchToProps)(EditSupplierModal)
